import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import logo from './logo.png';
import AcademicYearSelector from './AcademicYearSelector';

function Header({ user, onLogout, onProfileClick, onHomeClick, onMenuToggle, title = 'KOSTÜ Sınav Modülü' }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleProfilIconClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleDropdownLogout = () => {
    onLogout();
    setIsDropdownOpen(false);
  };

  const handleDropdownProfil = () => {
    setIsDropdownOpen(false);
    if (onProfileClick) {
      onProfileClick();
    }
  };

  const getUserName = () => {
    if (user?.name) {
      return user.name;
    }
    if (user?.student_number) {
      return user.student_number;
    }
    if (user?.email) {
      return user.email;
    }
    return 'Kullanıcı';
  };

  // Yil secici yalnizca personele gosterilir; ogrencinin gecmis yila gidip
  // arsiv sinav icerigini gormesi icin bir sebep yok.
  const isStudent = Boolean(user?.student_number) || user?.userType === 'student';
  const showYearSelector = Boolean(user) && !isStudent;

  const handleLogoClick = () => {
    if (onHomeClick) {
      onHomeClick();
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        {isMobile ? (
          <div className="header-row-mobile">
            {onMenuToggle && (
              <button
                onClick={onMenuToggle}
                className="mobile-menu-button"
                aria-label="Menü"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
            )}
            <img src={logo} alt="KOSTÜ Logo" className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
            <h2 className="header-title-mobile">{title}</h2>
            {showYearSelector && <AcademicYearSelector />}
            <div className="mobile-profile-wrapper" style={{ position: 'relative' }} ref={dropdownRef}>
              <button
                onClick={handleProfilIconClick}
                className="profil-icon-button"
                title="Profil"
                aria-haspopup={true}
                aria-expanded={isDropdownOpen}
              >
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  aria-label="Profil"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </button>
              {isDropdownOpen && (
                <div className="profil-dropdown-menu">
                  <button className="profil-dropdown-item" onClick={handleDropdownProfil}>
                    <span role="img" aria-label="Profil" style={{ marginRight: '8px' }}></span>
                    Profil Bilgileri
                  </button>
                  <button className="profil-dropdown-item" onClick={handleDropdownLogout}>
                    <span role="img" aria-label="Çıkış" style={{ marginRight: '8px' }}></span>
                    Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className="header-left">
              <img src={logo} alt="KOSTÜ Logo" className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
            </div>
            <div className="header-center">
              <h2 className="header-title">{title}</h2>
            </div>
            <div className="header-right" style={{ position: 'relative' }} ref={dropdownRef}>
              {showYearSelector && <AcademicYearSelector />}
              <button
                onClick={handleProfilIconClick}
                className="profil-icon-button"
                title="Profil"
                aria-haspopup={true}
                aria-expanded={isDropdownOpen}
              >
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  aria-label="Profil"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </button>
              {isDropdownOpen && (
                <div className="profil-dropdown-menu">
                  <div className="profil-dropdown-user-info">
                    <span style={{ fontSize: '0.85rem', color: '#666' }}>{getUserName()}</span>
                  </div>
                  <div className="profil-dropdown-divider"></div>
                  <button className="profil-dropdown-item" onClick={handleDropdownProfil}>
                    <span role="img" aria-label="Profil" style={{ marginRight: '8px' }}></span>
                    Profil Bilgileri
                  </button>
                  <button className="profil-dropdown-item" onClick={handleDropdownLogout}>
                    <span role="img" aria-label="Çıkış" style={{ marginRight: '8px' }}></span>
                    Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;

